export enum ClaimTableColumn {
	DETAILS = 'details',
	DATE = 'date',
	STATUS = 'status',
	DELETE = 'delete',
}
